// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/LgpdTerms_SaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /lgpd_terms/save
 *
 * Creates or updates an LGPD term record.
 * If `id` is present and > 0, updates an existing term.
 * If `ativo` is true, the activation is handled atomically by the model.
 */
import { registerContract } from './validate'

export interface LgpdTerms_SaveInput {
titulo: string
versao: string
conteudo: string
id?: number
ativo?: boolean
}

registerContract('LgpdTerms_SaveInput', {
  titulo:   { type: 'string',  required: true },
  versao:   { type: 'string',  required: true },
  conteudo: { type: 'string',  required: true },
  id:       { type: 'number',  required: false },
  ativo:    { type: 'boolean', required: false },
})
